import { PageRootEntity } from '../Entities/RootEntity';

import { APIKEYS } from './ApiKeys';
import { PageRoles } from './Roles';
import { PageCreateRole } from './Roles/Create';
import { PageEditRole } from './Roles/Edit';
import { PagePlatformSettings } from './Settings';
import { PageTeam } from './Team';
import { WEBHOOKS } from './Webhooks';

export const PLATFORM = {
  PlatformSettings: PagePlatformSettings,
  RootEntity: PageRootEntity,
  CreateRole: PageCreateRole,
  EditRole: PageEditRole,
  Roles: PageRoles,
  Team: PageTeam,
  ...APIKEYS,
  ...WEBHOOKS,
} as const;
